import utils from 'utils';

import {DetailNote} from '@components/export';
import {useLabel} from '@/hooks/export';

export const DetailSummary = (props: {
    item: apiOrderDetail,

    onNoteUpdate: (value: string) => void,
}) => {
    const label = useLabel();

    const handle = {
        getOrderSummary(order: apiOrderDetail) {
            let qty = 0;
            let priceSumQtyOne = 0;
            let priceSumQtyAll = 0;

            order.lines.map((product) => {
                qty += product.qty;
                priceSumQtyOne += +product.price;
                priceSumQtyAll += +product.price * product.qty;
            });

            return {
                qty,
                priceSumQtyOne: priceSumQtyOne.toFixed(2).replace('.', ','),
                priceSumQtyAll: priceSumQtyAll.toFixed(2).replace('.', ','),
            };
        },
    };

    return <div className={cmpClass}>
        <div className={classMap.row}>
            <div className={classMap.action}>
                <DetailNote
                    note={(props.item as apiOrderDetail).note}
                    popupOrigin={{
                        anchorOrigin: {
                            vertical: -5,
                            horizontal: 'left',
                        },
                        transformOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left',
                        },
                    }}

                    onUpdate={(value) => props.onNoteUpdate(value)}
                />
            </div>
            <div className={classMap.info}>
                <div className={classMap.infoRow}>
                    <div className={classMap.infoCell}>{label.total}:</div>
                    <div className={classMap.infoCell}>
                        {`${handle.getOrderSummary(props.item).qty} ${label.qty}`}
                    </div>
                    <div className={classMap.infoCell}>
                        {`${handle.getOrderSummary(props.item).priceSumQtyOne} ${label.currency}`}
                    </div>
                    <div className={classMap.infoCell}>
                        {`${handle.getOrderSummary(props.item).priceSumQtyAll} ${label.currency}`}
                    </div>
                </div>
            </div>
        </div>
    </div>;
};

const cmpClass = 'detail-summary';
const classMap = utils.generateClassMap(cmpClass, {
    row: 'row',
    action: 'action',
    info: 'info',
    infoRow: 'info-row',
    infoRowEdited: 'info-row--edited',
    infoCell: 'info-cell',
    note: 'note',
    noteActions: 'note-actions',
    additionalPaymentOption: 'additional-payment-option',
});
